import * as signalR from "@microsoft/signalr";

export const Constants = {
    animationDuration: 180,
    signalRLogLevel: signalR.LogLevel.Error,
};
